export default __webpack_public_path__ + "static/media/industry-dimension.4454e489.svg";